import { useEffect, useState } from "react";
//pages
import Home from "./pages";
import Services from "./pages/services";
import Faq from "./pages/faq";
import Contact from "./pages/contact";
import NotFound from "./pages/notFound";
//components
import Nav from "./components/Nav";
import Footer from "./components/Footer";
import FloatingLinks from "./components/FloatingLinks";
import CookiesPopup from "./components/CookiesPopup";
import Seo from "./components/Seo";
//router
import { Switch, Route, useLocation } from "react-router-dom";
import { paths } from "./constants/paths";
//animations, styles and themes
import { AnimatePresence } from "framer-motion";
import styled, { ThemeProvider, DefaultTheme } from "styled-components";
//page titles
//types
import type { Language } from "./typings";

function App() {
  const location = useLocation();

  const storeLanguage = (language: Language) => {
    localStorage.setItem("storedLanguage", language);
  };
  const storedLanguage = localStorage.getItem(
    "storedLanguage",
  ) as Language | null;
  const [language, setLanguage] = useState<Language>(
    storedLanguage ? storedLanguage : "Russian",
  );
  const [isPopupOpen, setPopupOpen] = useState(true);

  const theme: DefaultTheme = {
    font: language === "Russian" ? "Nunito" : "Poppins",
  };

  useEffect(() => {
    storedLanguage ? setLanguage(storedLanguage) : setLanguage("Russian");
  }, [storedLanguage]);

  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  return (
    <ThemeProvider theme={theme}>
      <StyledApp className="App">
        <Seo language={language} />
        {isPopupOpen ? (
          <CookiesPopup
            handleClosePopup={handleClosePopup}
            language={language}
          />
        ) : null}
        <Nav
          language={language}
          languageHandler={(language: Language) => {
            setLanguage(language);
            storeLanguage(language);
          }}
        />
        <AnimatePresence exitBeforeEnter>
          <Switch location={location} key={location.pathname}>
            <Route exact path={paths.home}>
              <Home language={language} />
            </Route>
            <Route path={paths.services}>
              <Services language={language} />
            </Route>
            <Route path={paths.faq}>
              <Faq language={language} />
            </Route>
            <Route path={paths.contact}>
              <Contact language={language} />
            </Route>
            <Route exact path="*">
              <NotFound language={language} />
            </Route>
          </Switch>
        </AnimatePresence>
        <FloatingLinks />
        <Footer language={language} />
      </StyledApp>
    </ThemeProvider>
  );
}

const StyledApp = styled.div`
  * {
    font-family: ${(props) => props.theme.font};
  }
`;

export default App;
